import { api } from '@marketplace-web/core-api/core-api-client-util'

import { FeedbackProblemOptionsResp } from '../types/feedback-problem'

export const getFeedbackProblemOptions = (userId: number, conversationId: number | string) =>
  api.get<FeedbackProblemOptionsResp>(
    `/users/${userId}/msg_threads/${conversationId}/problem_options`,
  )
